import React from 'react';
import PropTypes from 'prop-types';
import { Printer } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';
import { LockableButton } from 'components/shared/Lockable';
import { Button } from 'components/ui/button';

const Page = ({
  title = null,
  description = null,
  actionLabel = null,
  actionIcon = null,
  onAction = () => {},
  stats = null,
  headerContent = null,
  actionDisabled = false,
  hideEmptyStats = false,
  children = null,
  className = '',
  bodyClassName = '',
  actionClassName = '',
  removeContentStyles = false,
  onPrint = null,
  printTooltip = '',
}) => {
  return (
    <section
      className={`min-h-screen w-full bg-gradient-to-br from-slate-50 to-white flex items-start justify-center py-10 ${className}`}
    >
      <div className={`w-[90%] space-y-6 ${bodyClassName}`}>
        {headerContent}
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold">{title}</h2>
            <p className="text-gray-600">{description}</p>
          </div>

          <div className="flex gap-2 items-center">
            {actionLabel && actionLabel.length > 0 && (
              <LockableButton
                onClick={onAction}
                disabled={actionDisabled}
                variant="hajj"
                className={`mt-4 md:mt-0 ${actionClassName}`}
              >
                {actionIcon}
                {actionLabel}
              </LockableButton>
            )}

            {onPrint && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="hajj" size="icon" className="mt-4 md:mt-0" onClick={onPrint}>
                    <Printer />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{printTooltip}</p>
                </TooltipContent>
              </Tooltip>
            )}
          </div>
        </div>

        {(!hideEmptyStats || stats !== null) && <div>{stats}</div>}

        {/* Table or other content */}
        <div className={removeContentStyles ? '' : `bg-white rounded-sm border border-gray-200 p-4`}>{children}</div>
      </div>
    </section>
  );
};

Page.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  actionIcon: PropTypes.node,
  actionClassName: PropTypes.string,
  onAction: PropTypes.func,
  stats: PropTypes.node,
  headerContent: PropTypes.node,
  actionDisabled: PropTypes.bool,
  hideEmptyStats: PropTypes.bool,
  removeContentStyles: PropTypes.bool,
  bodyClassName: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Page;
